var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExplicit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.05457 0H8.33795C8.85782 0 9.30196 0.183222 9.67036 0.549665C10.0388 0.916109 10.223 1.35789 10.223 1.875V8.125C10.223 8.64211 10.0388 9.08389 9.67036 9.45034C9.30196 9.81678 8.85782 10 8.33795 10H2.05457C1.53469 10 1.09056 9.81678 0.722156 9.45034C0.353756 9.08389 0.169556 8.64211 0.169556 8.125V1.875C0.169556 1.35789 0.353756 0.916109 0.722156 0.549665C1.09056 0.183222 1.53469 0 2.05457 0ZM3.95641 3.04688H7.23275C7.34869 3.04688 7.4478 3.00688 7.53008 2.9269C7.61237 2.84691 7.65351 2.74926 7.65351 2.63393V2.08705C7.65351 1.97173 7.61237 1.87314 7.53008 1.79129C7.4478 1.70945 7.34869 1.66853 7.23275 1.66853H2.98586C2.87365 1.66853 2.77641 1.70945 2.69413 1.79129C2.61185 1.87314 2.5707 1.97173 2.5707 2.08705V7.91295C2.5707 8.02827 2.61185 8.12686 2.69413 8.20871C2.77641 8.29055 2.87365 8.33147 2.98586 8.33147H7.23275C7.34869 8.33147 7.4478 8.29055 7.53008 8.20871C7.61237 8.12686 7.65351 8.02827 7.65351 7.91295V7.36607C7.65351 7.25074 7.61237 7.15309 7.53008 7.0731C7.4478 6.99312 7.34869 6.95312 7.23275 6.95312H3.96763L3.95641 5.69196H6.32951C6.44545 5.69196 6.54457 5.65104 6.62685 5.5692C6.70913 5.48735 6.75027 5.38876 6.75027 5.27344V4.72656C6.75027 4.61124 6.70913 4.51265 6.62685 4.4308C6.54457 4.34896 6.44545 4.30804 6.32951 4.30804H3.95641V3.04688Z",
    fill: "#AAAAAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_73"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.0534,
    height: 10,
    fill: "white",
    transform: "translate(0.169556)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplicit);
export default __webpack_public_path__ + "static/media/explicit.888dc9f0138981f6e0f6b1513f17e47c.svg";
export { ForwardRef as ReactComponent };